// Show venue time, whatever the device thinks the timezone is.
//
// A kiosk till often can't have its timezone set (locked-down launcher, no
// Settings app) — the Elo I-Series sat on UTC and showed 00:05 while London
// was 01:05, with its clock otherwise accurate to a second. Every screen at a
// venue should read the same, so when the device's zone differs from the
// store's (config.timezone, from /pos-config), formatting defaults to the
// store's. Callers that pass their own timeZone are untouched, and a device
// already on the venue's zone is left completely alone.
import { config } from "../config/env";

let installed = false;

export function installStoreTimezone(): void {
  if (installed || typeof Intl === "undefined") return;
  const tz = config.timezone;
  if (!tz) return;
  try {
    const now = new Date();
    const fmt = (zone?: string) =>
      new Intl.DateTimeFormat("en-GB", {
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(now);
    // Unsupported zone id, or the device already agrees → nothing to do.
    if (fmt(tz) === fmt(undefined)) return;
  } catch {
    return; // engine can't do named zones: leave the device's own formatting
  }

  const withTz = (opts: unknown): Intl.DateTimeFormatOptions => {
    const o = (opts || {}) as Intl.DateTimeFormatOptions;
    return o.timeZone ? o : { ...o, timeZone: tz };
  };
  const proto = Date.prototype as unknown as Record<string, (...a: unknown[]) => string>;
  for (const name of ["toLocaleString", "toLocaleTimeString", "toLocaleDateString"] as const) {
    const orig = proto[name];
    proto[name] = function (this: Date, locales?: unknown, options?: unknown) {
      return orig.call(this, locales, withTz(options));
    } as (...a: unknown[]) => string;
  }
  installed = true;
  console.info(`[time] device timezone differs from the venue's — showing ${tz}`);
}

/** The venue's clock right now, for display next to a device-local one. */
export function storeTimeLabel(): string {
  try {
    return new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", timeZone: config.timezone });
  } catch {
    return "";
  }
}
